/* eslint-disable import/no-unresolved */
import React from 'react'

import { Tooltip, IconButton } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

import { PencilIcon } from 'components/icons/personalizedIcons'

const TooltipsUpdateEmailSeller = ({
  updateEmailSeller,
  tableMeta,
  newEmail,
  setRowAndColumSelectedEmail,
  rowAndColumSelectedEmail,
  setShowInputEmail,
  showInputEmail,
  setNewEmail,
  value,
}) => {
  return (
    <>
      {showInputEmail &&
      tableMeta.rowIndex === rowAndColumSelectedEmail.row &&
      rowAndColumSelectedEmail.colum === tableMeta.columnIndex ? (
        <>
          <Tooltip title="Actualizar">
            <IconButton
              onClick={() => {
                updateEmailSeller(tableMeta.rowData[0], newEmail, value)
              }}
            >
              <CheckIcon
                style={{
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'green',
                }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancelar">
            <IconButton
              onClick={() => {
                setRowAndColumSelectedEmail({
                  ...rowAndColumSelectedEmail,
                  row: tableMeta.rowIndex,
                })
                setShowInputEmail(!showInputEmail)
              }}
            >
              <CloseIcon
                style={{
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'red',
                }}
              />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              setNewEmail(value)
              setRowAndColumSelectedEmail({
                colum: tableMeta.columnIndex,
                row: tableMeta.rowIndex,
              })
              setShowInputEmail(!showInputEmail)
            }}
          >
            <PencilIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  )
}

export default TooltipsUpdateEmailSeller
